import { render, staticRenderFns } from "./contactUs.vue?vue&type=template&id=58d51136&scoped=true&"
import script from "./contactUs.vue?vue&type=script&lang=ts&"
export * from "./contactUs.vue?vue&type=script&lang=ts&"
import style0 from "./contactUs.vue?vue&type=style&index=0&id=58d51136&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d51136",
  null
  
)

export default component.exports